module.exports = __webpack_public_path__ + "static/img/6.35e555e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/eng/6.png
// module id = tfB3
// module chunks = 0